import { Condition } from '../proto/generated/nexus'

let onApply: ((condition: Condition) => void) | null = null
let onCancel: (() => void) | null = null

export function registerConditionalEntryAlertModalHandlers(
    onApplyCondition: (condition: Condition) => void,
    onCancelModal?: () => void
) {
    onApply = onApplyCondition
    onCancel = onCancelModal ?? null
}

export function clearConditionalEntryAlertModalHandlers() {
    onApply = null
    onCancel = null
}

export function invokeConditionalEntryApply(condition: Condition) {
    onApply?.(condition)
}

export function invokeConditionalEntryCancel() {
    onCancel?.()
}
